import React from "react";
import "./Skill.css";

const skillsData = {
  languages: [
    { name: "Java", description: "Programming Language", icon: "https://img.icons8.com/color/48/000000/java-coffee-cup-logo.png" },
    { name: "Python", description: "Programming Language", icon: "https://img.icons8.com/color/48/000000/python.png" },
    { name: "C/C++", description: "Programming Language", icon: "https://img.icons8.com/color/48/000000/c-plus-plus-logo.png" },
  ],
  frontend: [
    { name: "HTML5", description: "Frontend Development", icon: "https://img.icons8.com/color/48/000000/html-5.png" },
    { name: "CSS", description: "Frontend Styling", icon: "https://img.icons8.com/color/48/000000/css3.png" },
    { name: "Tailwind CSS", description: "Utility-First CSS Framework", icon: "https://adware-technologies.s3.amazonaws.com/uploads/technology/thumbnail/31/tailwind.png" },
    { name: "JavaScript", description: "Programming Language", icon: "https://img.icons8.com/color/48/000000/javascript.png" },
    { name: "ReactJS", description: "Frontend Framework", icon: "https://img.icons8.com/color/48/000000/react-native.png" },
  ],
  backend: [
    { name: "Node.js", description: "Backend Runtime", icon: "https://img.icons8.com/color/48/000000/nodejs.png" },
    { name: "Spring Boot", description: "Backend Framework", icon: "https://img.icons8.com/color/48/000000/spring-logo.png" },
  ],
  database: [
    { name: "MySQL", description: "Relational Database", icon: "https://img.icons8.com/color/48/000000/mysql-logo.png" },
    { name: "MongoDB", description: "NoSQL Database", icon: "https://img.icons8.com/color/48/000000/mongodb.png" },
    { name: "Redis", description: "In-Memory Database", icon: "https://img.icons8.com/color/48/000000/redis.png" },
    { name: "OracleDB", description: "Relational Database", icon: "https://img.icons8.com/color/48/000000/oracle-logo.png" },
  ],
  tools: [
    { name: "Postman", description: "API Testing", icon: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRJ5yPOAbr-LrEa8ANO47RBo4f2txsvjPL-fw&s" },
    { name: "SQL Server Data Tools", description: "Database Development", icon: "https://img.icons8.com/color/48/000000/sql.png" },
  ],
  hosting: [
    { name: "AWS", description: "Cloud Platform", icon: "https://img.icons8.com/color/48/000000/amazon-web-services.png" },
    { name: "Vercel", description: "Cloud Platform", icon: "https://smlvqzf0a1b66cku.public.blob.vercel-storage.com/images/Vercel%20Logo-IMoeV2W33gFclXzAfZxmAHqtjBuTzP.png" },
  ],
};

const mediaSkills = {
  contentCreation: [
    { name: "Video Editing", description: "Content Production", icon: "https://img.icons8.com/color/48/000000/video-editing.png" },
    { name: "Photography", description: "Visual Content", icon: "https://img.icons8.com/color/48/000000/camera.png" },
    { name: "Graphic Design", description: "Visual Design", icon: "https://img.icons8.com/color/48/000000/design.png" },
  ],
  platforms: [
    { name: "Instagram", description: "Social Media", icon: "https://img.icons8.com/color/48/000000/instagram-new.png" },
    { name: "TikTok", description: "Short Video Platform", icon: "https://img.icons8.com/color/48/000000/tiktok.png" },
    { name: "Facebook", description: "Social Network", icon: "https://img.icons8.com/color/48/000000/facebook.png" },
    { name: "LinkedIn", description: "Social Network", icon: "https://img.icons8.com/color/48/000000/linkedin.png" },
    { name: "Threads", description: "Social Network", icon: "https://upload.wikimedia.org/wikipedia/commons/d/db/Threads_%28app%29.png" },
  ],
  analytics: [
    { name: "Social Analytics", description: "Data Analysis", icon: "https://img.icons8.com/color/48/000000/analytics.png" },
    { name: "SEO", description: "Search Optimization", icon: "https://img.icons8.com/color/48/000000/search.png" },
  ],
  tools: [
    { name: "CapCut", description: "Video Editing", icon: "https://freelogopng.com/images/all_img/1664284836cap-cut-logo-png.png" },
    { name: "Canva", description: "Design Platform", icon: "https://img.icons8.com/color/48/000000/canva.png" },
    { name: "Photoshop", description: "Image Editing", icon: "https://img.icons8.com/color/48/000000/adobe-photoshop.png" },
  ]
};

const Skill = () => {
  return (
    <div className="skills-container">
      <h1 className="skills-title">My Technical Skills</h1>
      <div className="skills-content" style={{ display: 'flex', gap: '3rem' }}>
        {/* Information Technology Section */}
        <div className="info-tech-section" style={{ flex: '1 1 50%', borderRadius: '10px', padding: '1.5rem' }}>
          <h2>Information Technology Experience</h2>
          {Object.entries(skillsData).map(([category, skills]) => (
            <div className="skills-section" key={category}>
              <h2>{category.charAt(0).toUpperCase() + category.slice(1)}</h2>
              <div className="skills-grid">
                {skills.map((skill, index) => (
                  <div className="skill-card" key={index}>
                    <img src={skill.icon} alt={`${skill.name} icon`} className="skill-icon" />
                    <h3>{skill.name}</h3>
                    <p>{skill.description}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        {/* Digital Media Section */}
        <div className="media-dev-section" style={{ flex: '1 1 50%', borderRadius: '10px', padding: '1.5rem' }}>
          <h2>Digital Media & Content Creation</h2>
          {Object.entries(mediaSkills).map(([category, skills]) => (
            <div className="skills-section" key={category}>
              <h2>{category.charAt(0).toUpperCase() + category.slice(1)}</h2>
              <div className="skills-grid">
                {skills.map((skill, index) => (
                  <div className="skill-card" key={index}>
                    <img src={skill.icon} alt={`${skill.name} icon`} className="skill-icon" />
                    <h3>{skill.name}</h3>
                    <p>{skill.description}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Skill;
